import * as React from "react";
import { MoneyTextBoxEditor } from "../../../../../../../react-core/Html/Money/MoneyTextBoxEditor";

import { PartLoading } from "../../../../../../../react-core/Html/PartLoading";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { AccountAdviceType } from "../../../../../../../Wrap/Constants/Enums/Apply/AccountAdviceType";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { AssetClassType } from "../../../../../../../Wrap/Constants/Enums/Domain/Instrument/AssetClassType";
import { ModelPortfolioTabType } from "../../../../../../../Wrap/Constants/Enums/Domain/ModelPortfolioTabType";
import { OrderDirection } from "../../../../../../../Wrap/Constants/Enums/Domain/OrderDirection";
import { OrderType } from "../../../../../../../Wrap/Constants/Enums/Domain/OrderType";
import { ProductType } from "../../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { Instrument } from "../../../../../../../Wrap/Models/Domains/Investment/Instrument";
import { InstrumentSearchQuery } from "../../../../../../../Wrap/Models/Domains/Investment/InstrumentSearchQuery";
import { ClientTradableInvestments } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/ClientTradableInvestments";
import { User } from "../../../../../../../Wrap/Models/Models/User/User";
import { GENERIC_RESTRICTIONS_MESSAGE } from "../../../../../../Shared/Common/UserMessages";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { InvestmentSelectionAction } from "../../../../../../Shared/IST/Action/InvestmentSelectionAction";
import { DecisionMaker } from "../../../../../../Shared/IST/Components/DecisionMaker";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { QuantitySwitch } from "../../../../../../Shared/QuantitySwitch/QuantitySwitch";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Action } from "../../../../../Actions/Action";
import { ClientAccountStore, UserStore, TreasuredAssetsStore } from "../../../../../Stroes/Variable";
import { BuyAction } from "../../../Buy/Action/BuyAction";
import { InvestmentsAction } from "../../../PortfolioDashboard/Components/Investment/Action/InvestmentAction";
import { BuySellAllocationTable } from "../../../Common/BuySellInvestmentSelection/BuySellAllocationTable";
import {
    transformNewItem,
    clearAllocation,
} from "../../../Common/BuySellInvestmentSelection/BuySellAllocationTableHelper";
import { RestrictionStore } from "../../../Common/Restrictions/Variable";
import { OrderSetupReview } from "../../../Common/Review/Component/OrderSetupReview";
import { hasDecisionMaker } from "../../Resource/Content";

interface ISwitchFromInvestmentProps extends IProcessComponentProps {
    type: SubAccountType;
}

interface ISwitchFromInvestmentState {
    orderType: OrderType;
    isLoading: boolean;
    userInfo: User;
    treasuredAssetProductIds: Array<number>;
}

export class SwitchFromInvestment extends ProcessComponent<ISwitchFromInvestmentProps, ISwitchFromInvestmentState> {
    constructor(props: any) {
        super(props);
        this.state = {
            orderType:
                props.data.SellInvestmentList && props.data.SellInvestmentList.length > 0
                    ? props.data.SellInvestmentList[0].Type
                    : OrderType.Percentage,
            isLoading: true,
            userInfo: UserStore.getUserInfo(),
            treasuredAssetProductIds: null,
        };
    }

    private getTreasuredAssets() {
        const _treasuredAssetProductIds = TreasuredAssetsStore.getTreasuredAssetsProductIds();

        if (!_treasuredAssetProductIds) {
            const params = getQueryParameters();

            Action.getSubAccountTreasuredAssetsProductIds(params["subaccounthierarchyid"], (data: Array<number>) => {
                this.setState({ treasuredAssetProductIds: data });
            });
        } else {
            this.setState({ treasuredAssetProductIds: _treasuredAssetProductIds });
        }
    }

    componentDidMount() {
        super.componentDidMount();
        this.getTreasuredAssets();
        InvestmentSelectionAction.setIsUnderTransfer(true);
        const params = getQueryParameters();
        if (this.props.data.SellInvestmentList && this.props.data.SellInvestmentList.length > 0) {
            return this.setState({ isLoading: false });
        }
        BuyAction.getReuseHoldings(
            params["hierarchyid"],
            params["subaccounthierarchyid"],
            this.props.data.BatchId,
            (data: ClientTradableInvestments) => {
                const individual = data.CurrentIndividualHoldings.filter(
                    (ele) => ele.DisplayName != "GBP Cash" && ele.CurrQuantity > 0
                );
                const model = data.CurrentModelHoldings.filter((ele) => ele.CurrQuantity > 0);
                let ids = individual.map((ele) => ele.ProductId);
                ids = ids.concat(model.map((ele) => ele.ProductId));
                const query: InstrumentSearchQuery = {
                    ProductWrapperTypes: [this.props.type],
                    ProductIds: ids,
                    CanBeSold: true,
                    ResultsPerPage: ids.length,
                    ServiceProposition: data.AccountServiceProposition,
                };
                let currentAssets = [];
                InvestmentSelectionAction.searchInstruments(
                    query,
                    params["subaccounthierarchyid"],
                    (result: Instrument[]) => {
                        result.forEach((ele) => {
                            const obj = data.CurrentIndividualHoldings.find((item) => item.ProductId == ele.ProductId);
                            const model = data.CurrentModelHoldings.find((item) => item.ProductId == ele.ProductId);
                            if (obj) {
                                currentAssets = currentAssets.concat(
                                    transformNewItem(
                                        [{ Investment: obj }],
                                        this.state.orderType,
                                        OrderDirection.Sell,
                                        this.props.data.TotalValue
                                    )
                                );
                            } else if (model) {
                                currentAssets = currentAssets.concat(
                                    transformNewItem(
                                        [{ Investment: model }],
                                        this.state.orderType,
                                        OrderDirection.Sell,
                                        this.props.data.TotalValue
                                    )
                                );
                            }
                        });
                        if (currentAssets.length == 0) {
                            this.props.showErrorMsgPopUp(
                                ["There are no holdings in this product available to sell"],
                                true
                            );
                        } else {
                            this.props.onChange({
                                SellInvestmentList: currentAssets,
                                AccountAdviceType: data.ClientDetail
                                    ? data.ClientDetail.AccountAdviceType
                                    : AccountAdviceType.NotSpecified,
                            });
                        }
                        this.setState({ isLoading: false });
                    }
                );
            }
        );
    }

    componentWillUnmount() {
        InvestmentSelectionAction.setIsUnderTransfer(false);
    }

    private onUnderlyingToggle(isToggle, index, row) {
        const _data = this.props.data.SellInvestmentList.concat();
        if (isToggle) {
            const item = _data[index];
            _data[index].isToggle = isToggle;
            if (item.underlying) {
                this.props.onChange({ SellInvestmentList: _data });
            } else {
                if (row.modelPortfolioType) {
                    InvestmentSelectionAction.getUnderlying(
                        row.Instrument.ProductId,
                        ModelPortfolioTabType.HubModel,
                        (data) => {
                            _data[index].underlying = data;
                            this.props.onChange({ SellInvestmentList: _data });
                        }
                    );
                } else {
                    InvestmentsAction.getInvestmentsModelSingle(
                        getQueryParameters()["subaccounthierarchyid"],
                        row.Instrument.InstrumentCode,
                        JsonDateParser.toJsonDateNoOffset(new Date()),
                        AssetClassType.Tier1,
                        (result) => {
                            _data[index].underlying = { ModelPortfolioProducts: [] };
                            result.forEach((ele) => {
                                ele.Investments.forEach((item) => {
                                    _data[index].underlying.ModelPortfolioProducts.push({
                                        Name: item.DisplayName,
                                        ProductCode: item.InstrumentCode,
                                        ...item,
                                        targetAllocation: (item.Allocation * 100).toFixed(2) + "%",
                                    });
                                });
                            });
                            this.props.onChange({ SellInvestmentList: _data });
                        }
                    );
                }
            }
        } else {
            _data[index].isToggle = isToggle;
            this.props.onChange({ SellInvestmentList: _data });
        }
    }

    isValid() {
        if (RestrictionStore.buyDisabled() || RestrictionStore.sellDisabled()) {
            return false;
        }
        const hasNoInvestment = this.props.data.SellInvestmentList.length == 0;
        if (hasNoInvestment) {
            this.props.showErrorMsgPopUp(["There are no holdings in this product available to sell"]);
        }

        const over95PercentValueSells: any[] = this.props.data.SellInvestmentList.filter(
            (ele) => ele.Type == OrderType.Value && ele.OrderValue >= 0.95 * ele.Instrument.MarketValue.Amount
        ).map((ele) => ele.InstrumentCode);

        if (over95PercentValueSells.length > 0) {
            this.props.showErrorMsgPopUp([
                "Order Value cannot be greater than or equal to 95% of market value - " +
                    over95PercentValueSells.join(", "),
            ]);
        }

        return super.isValid() && !hasNoInvestment && over95PercentValueSells.length === 0;
    }

    public render(): JSX.Element {
        const { data, type, onChange } = this.props;
        const params = getQueryParameters();

        const notSellableInvestment = data.SellInvestmentList
            ? data.SellInvestmentList.filter(
                  (ele) => ele.Instrument.HasOpenValueSellOrder || ele.Instrument.SellOrders > 0
              )
            : [];
        const clientAccount = ClientAccountStore.getClientAccountInfo();

        const selectedInvestmentProductIds = data?.SellInvestmentList.filter(
            (ele) =>
                ele.BuyOrSell == OrderDirection.Sell &&
                ((ele.OrderValue || 0) > 0 || (ele.OrderQuantity || 0) > 0 || (ele.OrderPercentage || 0) > 0)
        ).map((ele) => ele.Instrument.ProductId);

        const SelectedTreasuredProductIds =
            this.state.treasuredAssetProductIds != null && this.state.treasuredAssetProductIds.length > 0
                ? selectedInvestmentProductIds.filter((ele) => this.state.treasuredAssetProductIds.includes(ele))
                : [];

        let restrictedMessage =
            "An account with suspended or restricted activities cannot setup switch from investments";
        const treasuredAssetsMessage =
            "As you have selected a Treasured asset, a sell instruction will be created on this occasion. The instrument will continue to remain protected from auto-disinvestment, unless this a full sell order.";

        if (this.state.userInfo != null && this.state.userInfo.IsAdviser) {
            restrictedMessage = GENERIC_RESTRICTIONS_MESSAGE;
        }

        return (
            <div className="ist-wrap">
                <h2 className="mb-18">
                    <span>Switch from investments</span>
                </h2>
                {(RestrictionStore.buyDisabled() || RestrictionStore.sellDisabled()) && (
                    <Alert alertType={AlertType.Error} message={restrictedMessage} />
                )}
                <OrderSetupReview data={data} subAccountType={type} process={ProcessType.Sell} colNum={1} />
                <MoneyTextBoxEditor
                    label="Total switch from"
                    cssWrapper="control-size-245"
                    value={data.TotalValue}
                    currency={CurrencyCode.GBP}
                    onBlur={(v) => {
                        const clearTable = clearAllocation(data.SellInvestmentList, OrderType.Value);
                        const totalMarketValue = clearTable.reduce(
                            (sum, curr) =>
                                (sum =
                                    sum +
                                    (curr.Instrument.HasOpenValueSellOrder || curr.Instrument.SellOrders > 0
                                        ? 0
                                        : curr.Instrument.MarketValue.Amount)),
                            0
                        );
                        const investmentList = clearTable.map((ele) => {
                            return {
                                ...ele,
                                OrderValue:
                                    ele.Instrument.HasOpenValueSellOrder || ele.Instrument.SellOrders > 0
                                        ? null
                                        : Number(
                                              ((ele.Instrument.MarketValue.Amount / totalMarketValue) * v).toFixed(2)
                                          ),
                                Type: OrderType.Value,
                            };
                        });
                        const total = investmentList.reduce((sum, curr) => (sum = sum + (curr.OrderValue || 0)), 0);
                        this.setState({ orderType: OrderType.Value });
                        onChange({ TotalValue: Number(total.toFixed(2)), SellInvestmentList: investmentList });
                    }}
                    onChange={(v) => {
                        onChange({ TotalValue: v ? Number(v.toFixed(2)) : v });
                    }}
                    maxNumberOfDecimalPlaces={{
                        errorMessage: "only allow two decimal places",
                        value: 2,
                    }}
                    moreThan={{
                        value: 0,
                        errorMessage: "Value must larger than 0",
                    }}
                    required="Please enter"
                />
                <hr />
                {notSellableInvestment.length > 0 && (
                    <Alert
                        alertType={AlertType.Warning}
                        message={`Instrument ${notSellableInvestment
                            .map((ele) => ele.InstrumentCode)
                            .toString()} currently has an open value sell order. No further sell instructions can be placed until this has been confirmed.`}
                    />
                )}
                <div className="row mt-5">
                    <div className="col-6"></div>
                    <div className="col-6 text-right">
                        {/* <QuantitySwitch
                            type={this.state.orderType}
                            onChange={(v) => {
                                onChange({
                                    SellInvestmentList: clearAllocation(
                                        data.SellInvestmentList,
                                        v,
                                        ProcessType.SwitchFrom
                                    ),
                                });
                                this.setState({ orderType: v });
                            }}
                            hasModel={
                                data.SellInvestmentList &&
                                data.SellInvestmentList.some((ele) =>
                                    [ProductType.ManagedModelPortfolio, ProductType.TailoredModelPortfolio].includes(
                                        ele.Instrument.Type
                                    )
                                )
                            }
                        /> */}
                    </div>
                </div>

                {SelectedTreasuredProductIds.length > 0 && (
                    <Alert alertType={AlertType.Warning} message={treasuredAssetsMessage} />
                )}

                <PartLoading isLoading={this.state.isLoading}>
                    <BuySellAllocationTable
                        excludeLimit
                        totalValue={data.TotalValue}
                        showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                        onToggle={(isToggle, index, rowData) => this.onUnderlyingToggle(isToggle, index, rowData)}
                        data={data.SellInvestmentList}
                        onChange={(list) => {
                            const total = list.reduce((sum, curr) => (sum = sum + Number(curr.OrderValue || 0)), 0);
                            onChange({
                                SellInvestmentList: list,
                                TotalValue: Number(Number(total).toFixed(2)),
                            });
                        }}
                        orderType={OrderType.Value}
                        process={ProcessType.SwitchFrom}
                        onRef={(ref) => this.appendChild(ref)}
                        onTreasuredAssetChange={() => {}}
                        ChecktreasuredAsset={this.state.treasuredAssetProductIds}
                        depositProducts={[]}
                        batchType={data.BatchType}
                    />
                    {hasDecisionMaker(data.SellInvestmentList) && (
                        <DecisionMaker
                            onRef={(ref) => this.appendChild(ref)}
                            data={data}
                            onChange={(v) => onChange(v)}
                            clAccountId={params["claccountid"]}
                            headAccountHierarchyId={clientAccount?.HierarchyId}
                            companyCode={clientAccount?.Company}
                            accountAdviceType={
                                clientAccount?.Discretionary
                                    ? AccountAdviceType.Discretionary
                                    : AccountAdviceType.NonDiscretionary
                            }
                            showErrorMsgPopUp={(msg, now) => this.props.showErrorMsgPopUp(msg, now)}
                        />
                    )}
                </PartLoading>
            </div>
        );
    }
}
